import appEnv from 'bundles/admin-dashboard/appEnv';
import setupAmplitudeGuidesAndSurveys from 'bundles/page/lib/amplitudeGuidesAndSurveys';
import appStarterFactory from 'bundles/page/lib/appStarterFactory';

setupAmplitudeGuidesAndSurveys();

export default appStarterFactory(appEnv);
